<template>
    <v-main>
        <div>
            <vue-page-transition name="fade-in-left">
                <router-view/>
            </vue-page-transition>
        </div>
    </v-main>
</template>
<script>
    import OverlayLoader from '@/app/shared/components/app-loader/Loader';
    export default {
        name: 'OffersRatePanel',
        components: {
            OverlayLoader,
        },
        beforeRouteEnter(to, from, next) {
            next(undefined);
        },
        beforeRouteUpdate(to, from, next) {
            next(undefined);
        },
        beforeCreate() {
        }
    };
</script>
